import React from 'react';
import { relationshipOptions } from '../../data/registration';
import { useProto } from '../../contexts/PrototypeContext';
import type { SomeoneElseInfo } from '../../types/volunteer';
export function someoneErrors(info: SomeoneElseInfo): Partial<Record<keyof SomeoneElseInfo, string>> {
  const e: Partial<Record<keyof SomeoneElseInfo, string>> = {};
  if (!info.firstName.trim()) e.firstName = 'Enter a first name.';
  if (!info.lastName.trim()) e.lastName = 'Enter a last name.';
  if (!/^\S+@\S+\.\S+$/.test(info.email)) e.email = 'Enter a valid email.';
  if (info.phone.replace(/\D/g, '').length < 10) e.phone = 'Enter a 10-digit phone number.';
  if (!info.relationship) e.relationship = 'Choose a relationship.';
  return e;
}
interface FieldProps {
  id: keyof SomeoneElseInfo;
  label: string;
  type?: string;
  autoComplete?: string;
  error?: string;
}
export function SomeoneElseForm({
  showErrors,
  size
}: {
  showErrors: boolean;
  size: 'mobile' | 'desktop';
}) {
  const {
    state,
    actions
  } = useProto();
  const errors = showErrors ? someoneErrors(state.someone) : {};
  const inputCls = (err?: string) => `mt-1 block w-full rounded-md border bg-white px-3 py-2.5 text-[15px] text-i9-ink outline-none focus:ring-2 focus:ring-i9-steel/40 ${err ? 'border-i9-red' : 'border-i9-line focus:border-i9-steel'}`;
  const field = ({
    id,
    label,
    type = 'text',
    autoComplete,
    error
  }: FieldProps) => <div key={id} data-id="element-325" data-mp="12f6gir07i8bi">
      <label htmlFor={`se-${id}`} className="text-[13px] font-semibold text-i9-ink" data-id="element-326" data-mp="12emylaak3jxh">{label}</label>
      <input id={`se-${id}`} type={type} autoComplete={autoComplete} value={state.someone[id]} onChange={e => actions.updateSomeone({
      [id]: e.target.value
    })} aria-invalid={!!error} aria-describedby={error ? `se-${id}-err` : undefined} className={inputCls(error)} data-id="element-327" data-mp="17gcbywl949oq" />
      {error && <p id={`se-${id}-err`} className="mt-1 text-xs font-medium text-i9-red" data-id="element-328" data-mp="2ssx9dz7ys4wq">{error}</p>}
    </div>;
  return <section aria-labelledby="se-title" className="rounded-lg border border-i9-line bg-i9-surface p-4 font-i9" data-id="element-329" data-mp="2qes2bsujreth">
      <h3 id="se-title" className="text-[16px] font-bold text-i9-ink" data-id="element-330" data-mp="2mbc976horwlj">Who will be volunteering?</h3>
      <p className="mt-1 text-[13px] leading-relaxed text-i9-muted" data-id="element-331" data-mp="2hdtxx9g755ad">
        We'll share this with your local i9 Sports team so they can reach out about coaching.
      </p>
      <div className={`mt-4 grid gap-3 ${size === 'desktop' ? 'grid-cols-2' : 'grid-cols-1'}`} data-id="element-332" data-mp="3a27xvuquibok">
        {field({
        id: 'firstName',
        label: 'First name',
        autoComplete: 'off',
        error: errors.firstName
      })}
        {field({
        id: 'lastName',
        label: 'Last name',
        autoComplete: 'off',
        error: errors.lastName
      })}
        {field({
        id: 'email',
        label: 'Email',
        type: 'email',
        autoComplete: 'off',
        error: errors.email
      })}
        {field({
        id: 'phone',
        label: 'Mobile phone',
        type: 'tel',
        autoComplete: 'off',
        error: errors.phone
      })}
        <div className={size === 'desktop' ? 'col-span-2' : ''} data-id="element-333" data-mp="3o0fws87fzn2d">
          <label htmlFor="se-relationship" className="text-[13px] font-semibold text-i9-ink" data-id="element-334" data-mp="3vcvp3rhiw5j3">Relationship to player</label>
          <select id="se-relationship" value={state.someone.relationship} onChange={e => actions.updateSomeone({
          relationship: e.target.value
        })} aria-invalid={!!errors.relationship} className={inputCls(errors.relationship)} data-id="element-335" data-mp="47ds2ok37g67">
            <option value="" data-id="element-336" data-mp="i52dpylzarcb">Select…</option>
            {relationshipOptions.map(r => <option key={r} data-id="element-337" data-mp="n4exublgtkb7">{r}</option>)}
          </select>
          {errors.relationship && <p className="mt-1 text-xs font-medium text-i9-red" data-id="element-338" data-mp="rvnadgi3dlsl">{errors.relationship}</p>}
        </div>
      </div>
    </section>;
}